export default "__VITE_ASSET__515552cb__"